import { render, staticRenderFns } from "./DateChar.vue?vue&type=template&id=58272841&scoped=true"
import script from "./DateChar.vue?vue&type=script&lang=js"
export * from "./DateChar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58272841",
  null
  
)

export default component.exports